import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  CircularProgress
} from '@mui/material';
import { adminApi } from 'src/utils/adminApi';
import SurveyResponseCard from './SurveyResponseCard';

export default function PlayerOnboardingDialog({ open, onClose, player }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (!open || !player?.id) {
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError('');
    setResponse(null);

    adminApi
      .userOnboarding(player.id)
      .then((result) => {
        if (!cancelled) {
          setResponse(result.data?.response ?? null);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [open, player?.id]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ color: '#F3F4F6' }}>
        Onboarding — {player?.name}
      </DialogTitle>
      <DialogContent dividers sx={{ bgcolor: '#0B0E14' }}>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress size={28} />
          </Box>
        )}

        {error && (
          <Typography sx={{ color: '#F87171', mb: 1, fontSize: '0.85rem' }}>
            {error}
          </Typography>
        )}

        {!loading && !error && !response && (
          <Typography sx={{ color: '#9CA3AF', py: 3, textAlign: 'center' }}>
            This player has not completed onboarding yet.
          </Typography>
        )}

        {!loading && response && (
          <SurveyResponseCard response={response} headingPrefix="Onboarding" />
        )}
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
